import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=22c6a4f4&scoped=true"
import script from "./Admin.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Admin.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./Admin.vue?vue&type=style&index=0&id=22c6a4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c6a4f4",
  null
  
)

export default component.exports